import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/_config/config';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DataService } from '../_service/data.service';
import { ExcelService } from '../_service/excel.service';
import { environment } from 'src/environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import __ from 'underscore';
import { ThrowStmt } from '@angular/compiler';
import  *  as  column  from  './columnList.json';
declare const Highcharts: any;
declare const $: any;
declare const moment: any;

@Component({
  selector: 'app-comparative-report',
  templateUrl: './comparative-report.component.html',
  styleUrls: ['./comparative-report.component.scss']
})
export class ComparativeReportComponent implements OnInit {

  outletDropdownSettings:IDropdownSettings;
  parentDropdownSettings: IDropdownSettings;
  zoneDropdownSettings: IDropdownSettings;
  regionDropdownSettings: IDropdownSettings;
  columnDropdownSettings: IDropdownSettings;
  channelDropdownSettings: IDropdownSettings;
  outletTypeDropdownSettings: IDropdownSettings;
  public config:any = new Config();
  public regionList:any = [];
  public zoneList:any = [];
  public parentList:any = [];
  public outletList: any = [];
  public columnList : any = [];
  public channelList: any = [];
  public outletTypeList: any = [];
  public filterForm:FormGroup;
  public start_date:any = moment().subtract('days', 30);
  public end_date:any = moment();
  public comp_start_date:any = moment().subtract('days', 30);
  public comp_end_date:any = moment();
  public regionQualification:any = [];
  public outletQualification: any=[];
  public zoneQualification:any = [];
  public allIndaiQualification: any = [];
  public topModel:any = [];
  public imageUrl:string = environment.imageUrl;
  totalLeads:any = { total:0, qualified:0, sales:0, new:0 };
  loginData: any;
  zoneStatus: Boolean = false;
  regionStatus: Boolean = false;
  parentStatus: Boolean = false;
  outletStatus: Boolean= false;
  channelStatus:Boolean = false;
  selectedZone = [];
  selectedRegion = [];
  selectedParent = [];
  selectedOutlet = [];
  selectedColumn = [];
  selectedChannel = [];
  selectedOutletType = [];
  zone=[];
  region=[];
  parent=[];
  outlet=[];
  channel = []
  apiReq = {
      zone:'',
      region:'',
      parent: '',
      outlet: '',
      channel:'',
      outletType: ''
  };
  firstTimeRun: Boolean = true;
  columnName: any;
  channelName: any = '';
  outletTypeName: any= '';

  constructor(
      private fb:FormBuilder,
      private dataService:DataService,
      private ExcelService: ExcelService
      ) {

      this.filterForm = this.fb.group({
          zone:[''],
          region:[''],
          parent_group:[''],
          outlet:[''],
          start_date:[this.start_date.format('YYYY-MM-DD')],
          end_date:[this.end_date.format('YYYY-MM-DD')],
          comp_start_date:[this.comp_start_date.format('YYYY-MM-DD')],
          comp_end_date:[this.comp_end_date.format('YYYY-MM-DD')], 
          userType: ['']
      })
  }


  ngOnInit() {
    this.loginData = (this.dataService.getCookies('loginData'))? JSON.parse(this.dataService.getCookies('loginData')).acl : JSON.parse(localStorage.getItem('loginData')).acl;
    if(this.loginData.userType === 6) { // TSM/RO
            this.parentStatus = true;
            this.getAllParent('aa');
        } else if(this.loginData.userType === 8) { // Zonal
            this.regionStatus = true;
            this.parentStatus = true;
            this.getAllRegion('aa');
        } else if(this.loginData.userType === 1) { // Agency or HO
            this.regionStatus = true;
            this.parentStatus = true;
            this.zoneStatus = true;
            this.channelStatus = true;
            this.getAllZone();
        }  else if(this.loginData.userType === 9){
          this.parentStatus = true;
          this.outletStatus = true;
          this.channelStatus = true;
          this.getAllChannel("''");
        } else if(this.loginData.userType === 10) { // Zonal manager
          this.regionStatus = true;
          this.parentStatus = true;
          // this.zoneStatus = true;
          this.channelStatus = true;
          this.getAllRegion('aa');
        }  else {
            this.regionStatus = true;
            this.outletStatus = true;
            this.channelStatus = true;
            this.getAllRegion("''");
        }

        
        this.filterForm.patchValue({
            "userType": this.loginData.userType
        })
        let options = {
            timePicker: false,
            startDate: this.start_date,
            endDate: this.end_date,
            maxDate:this.end_date,
            // ranges: {
            //     'Today': [moment(), moment()],
            //     'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            //     'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            //     'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            //     'This Month': [moment().startOf('month'), moment().endOf('month')],
            //     'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            // },
            locale: {
                format: 'DD MMM YYYY'
            }
        }
        // var formValue = this.dataService.getCookies('hyperLocalFilter') || '';
        this.filterForm.patchValue({
            "start_date": "2021-01-01",
            "end_date": "2021-01-24"
        });
        if(this.filterForm.value) {
            // formValue = JSON.parse(formValue);
            // this.filterForm.patchValue(formValue);
            // if(formValue.zone && formValue.region == ''){
            //     let event = { target:{ value:formValue.zone } };
            //     this.changeValue(event, 'zone');
            // }
            options = __.extend(options, {
                startDate:moment(this.filterForm.value.start_date, 'YYYY-MM-DD'),
                endDate:moment(this.filterForm.value.end_date, 'YYYY-MM-DD'),
                "maxSpan": {
                    "days": 30
                }
            })
        }
       
        var self = this;
        $('input[name="daterange_input"]').daterangepicker(options, callBack);
        function callBack(start, end){
            self.filterForm.controls['start_date'].setValue(moment(start).format('YYYY-MM-DD'))
            self.filterForm.controls['end_date'].setValue(moment(end).format('YYYY-MM-DD'))
        }

        let options1 = {
          timePicker: false,
          startDate: this.comp_start_date,
          endDate: this.comp_end_date,
          maxDate:this.comp_end_date,
          // ranges: {
          //     'Today': [moment(), moment()],
          //     'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          //     'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          //     'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          //     'This Month': [moment().startOf('month'), moment().endOf('month')],
          //     'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          // },
          locale: {
              format: 'DD MMM YYYY'
          }
      }
      // var formValue = this.dataService.getCookies('hyperLocalFilter') || '';
      this.filterForm.patchValue({
        "comp_start_date": moment().clone().startOf('month').format('YYYY-MM-DD'),
        "comp_end_date": moment(new Date()).format('YYYY-MM-DD')
    });
      if(this.filterForm.value) {
          // formValue = JSON.parse(formValue);
          // this.filterForm.patchValue(formValue);
          // if(formValue.zone && formValue.region == ''){
          //     let event = { target:{ value:formValue.zone } };
          //     this.changeValue(event, 'zone');
          // }
          options = __.extend(options1, {
              startDate:moment(this.filterForm.value.comp_start_date, 'YYYY-MM-DD'),
              endDate:moment(this.filterForm.value.comp_end_date, 'YYYY-MM-DD'),
              "maxSpan": {
                  "days": 30
              }
          })
      }
     
      var self = this;
      $('input[name="daterange_input1"]').daterangepicker(options, callBack1);
      function callBack1(start, end){
          self.filterForm.controls['comp_start_date'].setValue(moment(start).format('YYYY-MM-DD'))
          self.filterForm.controls['comp_end_date'].setValue(moment(end).format('YYYY-MM-DD'))
      }

        
        this.zoneSetting();
        this.regionSetting();
        this.parentSetting();
        this.outletSetting();
        this.columnSetting();
        this.channelSetting();
        this.outletTypeSetting();
        // this.getAllZone();
  }


  zoneSetting() {
    this.zoneDropdownSettings = {
        singleSelection: false,
        idField: 'zone',
        textField: 'zone',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
}

onZoneSelect(item: any) {
    this.selectedZone.push(item.zone);
    let data = "'" + this.selectedZone.join("','") + "'"
    console.log('selectedZone', data);
    this.region = [];
    this.parent = [];
    this.outlet = [];
    this.apiReq.zone = data;
    this.getAllRegion(data)
}
onZoneAll(items: any) {
    this.selectedZone = [];
    this.region = [];
    this.parent = [];
    this.outlet = [];
    console.log(items)
    for(let i =0 ; i<items.length; i++) {
        this.selectedZone.push(items[i].zone);
    }
    let data = "'" + this.selectedZone.join("','") + "'"
    this.apiReq.zone = data;
    this.getAllRegion(data)
}
onZoneDeSelect(item: any) {
    this.selectedZone.splice(this.selectedZone.indexOf(item.zone), 1);
    let data = "'" + this.selectedZone.join("','") + "'";
    this.apiReq.zone = data;
    this.region = [];
    this.parent = [];
    this.outlet = [];
    this.getAllRegion(data)
}

onZoneDeAll(){
    this.region = [];
    this.parent = [];
    this.outlet = [];
    this.selectedZone = [];
    this.regionList = [];
    this.apiReq.zone = '';
    this.getAllRegion("''")
}
regionSetting() {
    this.regionDropdownSettings = {
        singleSelection: false,
        idField: 'region',
        textField: 'region',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
}
onRegionSelect(item: any) {
    this.parent = [];
    this.outlet = [];
    this.selectedRegion.push(item.region);
    let data = "'" + this.selectedRegion.join("','") + "'"
    this.apiReq.region = data;
    this.getAllParent(data)
}
  onRegionAll(items: any) {
    this.selectedRegion = [];
    for(let i =0 ; i<items.length; i++) {
        this.selectedRegion.push(items[i].region);
    }
    let data = "'" + this.selectedRegion.join("','") + "'"
    this.apiReq.region = data;
    this.parent = [];
    this.outlet = [];
    this.getAllParent(data)
}

onRegionDeSelect(item: any) {
    this.selectedRegion.splice(this.selectedRegion.indexOf(item.region), 1);
    let data = "'" + this.selectedRegion.join("','") + "'";
    this.apiReq.region = data;
    this.parent = [];
    this.outlet = [];
    console.log('data', data)        
    this.getAllParent(data)
}

onRegionDeAll(){
    this.parent = [];
    this.outlet = [];
    this.selectedRegion = [];
    this.parentList = [];
    this.apiReq.region = '';
    this.getAllParent("''");
}
parentSetting() {
    this.parentDropdownSettings = {
        singleSelection: false,
        idField: 'business_unit_id',
        textField: 'parent',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
}
onParentSelect(item: any) {
    this.selectedParent.push(item.business_unit_id);
    let data = "'" + this.selectedParent.join("','") + "'"
    this.apiReq.parent = data;
    this.outlet = [];
    this.getAllOutlet(data)
}
  onParentAll(items: any) {
    this.selectedParent = [];
    for(let i =0 ; i<items.length; i++) {
        this.selectedParent.push(items[i].business_unit_id);
    }
    let data = "'" + this.selectedParent.join("','") + "'";
    this.outlet = [];
    this.apiReq.parent = data;
    this.getAllOutlet(data)
}

onParentDeSelect(item: any) {
    this.selectedParent.splice(this.selectedParent.indexOf(item.business_unit_id), 1);
    let data = "'" + this.selectedParent.join("','") + "'";
    this.apiReq.parent = data;
    this.outlet = [];        
    this.getAllOutlet(data)
}

onParentDeAll(){
    this.selectedParent = [];
    this.outlet = [];
    this.outletList = [];
    this.apiReq.parent = '';
    this.getAllOutlet("''");

}

outletSetting() {
    this.outletDropdownSettings = {
        singleSelection: false,
        idField: 'webform_id',
        textField: 'outlet',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
}
onOutletSelect(item: any) {
    this.selectedOutlet.push(item.webform_id);
    let data = "'" + this.selectedOutlet.join("','") + "'"
    this.apiReq.outlet = data;
    this.advanceFilter();
}
onOutletAll(items: any) {
    this.selectedOutlet = [];
    for(let i =0 ; i<items.length; i++) {
        this.selectedOutlet.push(items[i].webform_id);
    }
    let data = "'" + this.selectedOutlet.join("','") + "'"
    this.apiReq.outlet = data;
    this.advanceFilter();
}

onOutletDeSelect(item: any) {
    this.selectedOutlet.splice(this.selectedOutlet.indexOf(item.webform_id), 1);
    let data = "'" + this.selectedOutlet.join("','") + "'";
    this.apiReq.outlet = data;

    this.advanceFilter();
        }

onOutletDeAll(){
    this.selectedOutlet = [];
    this.apiReq.outlet = '';  
    this.advanceFilter();
}



channelSetting() {
    this.channelDropdownSettings = {
        singleSelection: false,
        idField: 'channel',
        textField: 'channel',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
}
onChannelSelect(item: any) {
    this.selectedChannel.push(item.channel);
    let data = "'" + this.selectedChannel.join("','") + "'"
    this.apiReq.channel = data;
    this.channelName = data;
    this.parent = [];
    this.outlet = [];
    this.getAllParent(this.apiReq.region)
}
  onChannelAll(items: any) {
    this.selectedChannel = [];
    for(let i =0 ; i<items.length; i++) {
        this.selectedChannel.push(items[i].channel);
    }
    let data = "'" + this.selectedChannel.join("','") + "'";
    this.parent = [];
    this.outlet = [];
    this.apiReq.channel = data;
    this.channelName = data;
    this.getAllParent(this.apiReq.region)
}

onChannelDeSelect(item: any) {
    this.selectedChannel.splice(this.selectedChannel.indexOf(item.channel), 1);
    let data = "'" + this.selectedChannel.join("','") + "'";
    this.apiReq.channel = data;
    this.parent = [];
    this.outlet = [];
    this.channelName = data;       
    this.getAllParent(this.apiReq.region)
}

onChannelDeAll(){
    this.selectedChannel = [];
    this.parent = [];
    this.outlet = [];
    this.parentList = [];
    this.apiReq.channel = '';
    this.channelName = '';
    this.getAllParent(this.apiReq.region);

}

outletTypeSetting() {
    this.outletTypeDropdownSettings = {
        singleSelection: false,
        idField: 'outlettype',
        textField: 'outlettype',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
}
onOutletTypeSelect(item: any) {
    this.selectedOutletType.push(item.outlettype);
    let data = "'" + this.selectedOutletType.join("','") + "'"
    this.apiReq.outletType = data;
    this.outletTypeName = data;
    this.getAllOutlet(this.apiReq.region);
}
onOutletTypeAll(items: any) {
    this.selectedOutletType = [];
    for(let i =0 ; i<items.length; i++) {
        this.selectedOutletType.push(items[i].outlettype);
    }
    let data = "'" + this.selectedOutletType.join("','") + "'"
    this.apiReq.outletType = data;
    this.outletTypeName = data;
    this.getAllOutlet(this.apiReq.region);
}

onOutletTypeDeSelect(item: any) {
    this.selectedOutletType.splice(this.selectedOutletType.indexOf(item.outlettype), 1);
    let data = "'" + this.selectedOutletType.join("','") + "'";
    this.apiReq.outletType = data;
    this.outletTypeName = data;
    this.getAllOutlet(this.apiReq.region);
        }

onOutletTypeDeAll(){
    this.selectedOutletType = [];
    this.apiReq.outletType = '';  
    this.outletTypeName = '';
    this.getAllOutlet(this.apiReq.region);
}

columnSetting() {
  this.columnDropdownSettings = {
      singleSelection: false,
      idField: 'column_name',
      textField: 'view_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
}
onColumnSelect(item: any) {
  this.selectedColumn.push(item.column_name);
  // let data = "'" + this.selectedColumn.join("','") + "'"
  // this.columnName = data;
  // console.log(this.columnName)
}
onColumnAll(items: any) {
  console.log(items);
  this.selectedColumn = [];
  for(let i =0 ; i<items.length; i++) {
      this.selectedColumn.push(items[i].column_name);
  }
  // let data = "'" + this.selectedColumn.join("','") + "'"
  // this.columnName = data;
}

onColumnDeSelect(item: any) {
  this.selectedColumn.splice(this.selectedColumn.indexOf(item.column_name), 1);
  // let data = "'" + this.selectedColumn.join("','") + "'";
  // this.columnName = data;
  // console.log('selectedColumn', data);
      }

onColumnDeAll(){
  this.selectedColumn = [];
  this.columnName = '';
  
}

public advanceFilter(){
  if(this.firstTimeRun) {
      this.apiReq = {
          zone:'',
          region:'',
          parent: '',
          outlet: '',
          channel:'',
          outletType: ''
      }
  }
  // this.sourceChart('ww')
   this.getTotalLeads();
   this.callWebLeads();
   this.getLeadSourceCount();
   this.getLeadType();
   this.callAttended();
   this.leadTimeResponse()
  // this.getLeadTypeCount();
  // this.getLeadSourceCount();
  // this.getLeadRegionCount();
  // this.getLeadOutletCount();
  // this.getLeadZoneCount();
  // this.getAllIndia();
  // this.getTopModelCount();
  // this.getLeadHistory();
  this.columnList = column['default'];
  // this.getAllColumn('hyperlocal_lead_report')
  this.firstTimeRun = false;
}

download() {
  if (this.selectedColumn.length === 0) {
      this.dataService.showError('Please select column name.');
  } else {
      this.dataService.startLoader();

  let finalData = {
      one: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.channelName,
      outletType: this.apiReq.outletType,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
      comp_start_date: this.filterForm.value.comp_start_date,
      comp_end_date: this.filterForm.value.comp_end_date,
      columnList: this.selectedColumn
  }
  this.dataService.post('comparative/downloadComrative', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
         console.log('download data', res['data']);
         if (res['data'].length) {
          this.ExcelService.exportAsExcelFile(res['data'], 'Comprative_report');
          } else {
              this.dataService.showError('No Data Found.')
          }            }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}
}

public getAllZone(){
  this.dataService.startLoader();
  let data = {
    loginInfo: {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      },
  }
  this.dataService.postMaster('filter/getZone', data).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.zoneList = res['data'];
          let arr = [];
          for(let i =0 ;i< this.zoneList.length;i++) {
              arr.push(this.zoneList[i].zone);
          }
          let data = "'" + arr.join("','") + "'"
          this.apiReq.zone = data;
          console.log('this.apiReq.zone', this.apiReq.zone)
          this.getAllRegion(data);
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public getAllRegion(zoneName){
  this.dataService.startLoader();
  let data;
  data = {
    loginInfo: {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      },
    zone: zoneName
  }
  if(this.loginData.userType === 8 || this.loginData.userType === 10) {
      data = {
        loginInfo: {
          zone: this.apiReq.zone,
          region: this.apiReq.region,
          parent: this.apiReq.parent,
          outlet: this.apiReq.outlet
          },
        zone: `'${this.loginData.zone}'`
      }
  }
  this.dataService.postMaster('filter/getRegion', data).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.regionList = res['data'];
          let arr = []
          for(let i =0 ; i<this.regionList.length; i++) {
              arr.push(this.regionList[i].region);
          }
          let data = "'" + arr.join("','") + "'"
          this.apiReq.region = data;
          this.getAllChannel(data);

      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public getAllChannel(regionName){
  this.dataService.startLoader();
  let data;
  data = {
    loginInfo: {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      },
      region: regionName
  }
  this.dataService.postMaster('filter/getAllChannel', data).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.channelList = res['data'];
          let arr = []
          for(let i =0 ; i<this.channelList.length; i++) {
              arr.push(this.channelList[i].channel);
          }
          let data = "'" + arr.join("','") + "'"
          this.apiReq.channel = data;
          this.channelName = data;
          this.getAllParent(regionName);

      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public getAllParent(regionName){
  
  this.dataService.startLoader();
  let data;
  data = {
    loginInfo: {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      },
    region: regionName,
    channel: this.channelName
  }
  if(this.loginData.userType === 6) {
      data = {
        loginInfo: {
          zone: this.apiReq.zone,
          region: this.apiReq.region,
          parent: this.apiReq.parent,
          outlet: this.apiReq.outlet,
          },
        region: `'${this.loginData.region}'`,
        channel: this.channelName
      }
  }
  this.dataService.postMaster('filter/getParent', data).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.parentList = res['data'];
          let arr = []
          for(let i =0 ; i<this.parentList.length; i++) {
              arr.push(this.parentList[i].business_unit_id);
          }
          let data = "'" + arr.join("','") + "'"
          this.apiReq.parent = data;
          // this.getAllOutlet(data);
          this.getAllOutletType(data);
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public getAllOutletType(regionName){
  this.dataService.startLoader();
  let data;
  data = {
    loginInfo: {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      },
      region: regionName
  }
  this.dataService.postMaster('filter/getAllOutletType', data).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.outletTypeList = res['data'];
          let arr = []
          for(let i =0 ; i<this.outletTypeList.length; i++) {
              arr.push(this.outletTypeList[i].channel);
          }
          let data = "'" + arr.join("','") + "'"
          this.apiReq.outletType = data;
          this.outletTypeName = data;
          this.getAllOutlet(regionName);

      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public getAllOutlet(parentName){
  this.dataService.startLoader();
  let data = {};
  if(this.loginData.userType === 2) {
      data = {
          loginInfo: {
          zone: this.apiReq.zone,
          region: this.apiReq.region,
          parent: this.apiReq.parent,
          outlet: this.apiReq.outlet,
          },
          region:this.apiReq.region,
          business_unit_id:this.loginData.business_unit_id,
          channel: this.channelName,
          outletType: this.outletTypeName,
          userType: this.loginData.userType
      }
  } else {
      data = {
        loginInfo: {
          zone: this.apiReq.zone,
          region: this.apiReq.region,
          parent: this.apiReq.parent,
          outlet: this.apiReq.outlet,
          },
          parent: parentName,
          channel: this.channelName,
          outletType: this.outletTypeName,
          userType: this.loginData.userType
      }
  }
  this.dataService.postMaster('filter/getOutlet',data).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.outletList = res['data'];
          let arr = []
          for(let i =0 ; i<this.outletList.length; i++) {
              arr.push(this.outletList[i].webform_id);
          }
          let data = "'" + arr.join("','") + "'"
          this.apiReq.outlet = data;
          
          this.advanceFilter();

      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public getAllColumn(tabName){
  
  this.dataService.startLoader();
  
  this.dataService.postMaster('filter/getColumnName', {tableName: tabName}).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.removeByAttr(res['data'], 'column_name', 'day');
          this.removeByAttr(res['data'], 'column_name', "day_name")
          this.removeByAttr(res['data'], 'column_name', 'year')
          this.removeByAttr(res['data'], 'column_name', 'month')
          this.removeByAttr(res['data'], 'column_name', 'yearmonth');
          this.removeByAttr(res['data'], 'column_name', 'date')
          res['data'].push({column_name: 'qualifedNonSales'});
          res['data'].push({column_name: 'search_leads'});
          res['data'].push({column_name: 'call_actioned'});
          console.log(JSON.stringify(res['data']))
          this.columnList = res['data'];
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

removeByAttr (arr, attr, value){
  var i = arr.length;
  while(i--){
     if( arr[i] 
         && arr[i].hasOwnProperty(attr) 
         && (arguments.length > 2 && arr[i][attr] === value ) ){ 

         arr.splice(i,1);

     }
  }
  return arr;
}
public clearFilter(){
  this.dataService.removeCookies('hyperLocalFilter', '');
  this.filterForm.patchValue({
      zone:'', region:'', parent_group:'', outlet:'',
      start_date:this.start_date.format('YYYY-MM-DD'), 
      end_date:this.end_date.format('YYYY-MM-DD')
  })
  this.ngOnInit();
}

public getTotalLeads(){
  this.dataService.startLoader();
  let finalData = {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outlet: this.apiReq.outlet,
      channel: this.channelName,
      outletType: this.apiReq.outletType,
      start_date: this.filterForm.value.start_date,
      end_date: this.filterForm.value.end_date,
      comp_start_date: this.filterForm.value.comp_start_date,
      comp_end_date: this.filterForm.value.comp_end_date
  }
  this.dataService.post('comparative/compCount', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          console.log('res', res)
          this.totalLeads = res['data'];
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

callWebLeads() {
  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    comp_start_date: this.filterForm.value.comp_start_date,
    comp_end_date: this.filterForm.value.comp_end_date
}
    this.dataService.post('comparative/webCallLeads', finalData).subscribe(res=>{
        this.dataService.stopLoader();
        if(res['code'] == 200){
          this.callLead(res['data'].callLeads)
          this.webLead(res['data'].webLeads)
        }
        else{
            this.dataService.showError(res['message']);
            if(res['code'] == 401){
                this.dataService.logout();
            }
        }
    }, err=>{
        this.dataService.stopLoader();
        this.dataService.showError(err['message']);
    })
}

public callLead(info) {
  console.log(info)
  Highcharts.chart('callLeads', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>'
    },
  
    series: [
      {
        name: "",
        colorByPoint: true,
        data: info
      }
    ]
  });
}

public webLead(info) {
  Highcharts.chart('webLeads', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>'
    },
  
    series: [
      {
        name: "",
        colorByPoint: true,
        data: info
      }
    ]
  });
}

public getLeadSourceCount(){

  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    comp_start_date: this.filterForm.value.comp_start_date,
    comp_end_date: this.filterForm.value.comp_end_date
}
  this.dataService.post('comparative/getSourceData', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.sourceChart(res['data']);
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}
public sourceChart(leadSource) {

  Highcharts.chart('source_chart', {
      chart: {
          type: 'bar',
          height: 380
      },
      exporting: { enabled: false },
      title: {
          text: ''
      },
      subtitle: {
          text: ''
      },
      xAxis: {
          categories:[`${this.filterForm.value.start_date} - ${this.filterForm.value.end_date}`, `${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date}`],
          title: {
              text: null
          }
      },
      yAxis: {
          min: '',
          title: {
              text: 'Leads',
              align: 'high'
          },
          labels: {
              overflow: 'justify'
          }
      },
      tooltip: {
          valueSuffix: ' Leads'
      },
      plotOptions: {
          bar: {
              dataLabels: {
                  enabled: true
              }
          }
      },
      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: 10,
          y: -10,
          floating: false,
          borderWidth: 1,
          backgroundColor:
              Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
          shadow: true
      },
      credits: {
          enabled: false
      },
      series: leadSource
  });
}

public getLeadType(){

  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    comp_start_date: this.filterForm.value.comp_start_date,
    comp_end_date: this.filterForm.value.comp_end_date
}
  this.dataService.post('comparative/getLeadType', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.leadTypeChart(res['data']);
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public leadTypeChart(leadType) {
  Highcharts.chart('leadType_chart', {
      chart: {
          type: 'bar',
          height: 380
      },
      exporting: { enabled: false },
      title: {
          text: ''
      },
      subtitle: {
          text: ''
      },
      xAxis: {
          categories:[`${this.filterForm.value.start_date} - ${this.filterForm.value.end_date}`, `${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date}`],
          title: {
              text: null
          }
      },
      yAxis: {
          min: '',
          title: {
              text: 'Leads',
              align: 'high'
          },
          labels: {
              overflow: 'justify'
          }
      },
      tooltip: {
          valueSuffix: ' Leads'
      },
      plotOptions: {
          bar: {
              dataLabels: {
                  enabled: true
              }
          }
      },
      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: 10,
          y: -10,
          floating: false,
          borderWidth: 1,
          backgroundColor:
              Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
          shadow: true
      },
      credits: {
          enabled: false
      },
      series: leadType
  });
}

public callAttended(){

  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    comp_start_date: this.filterForm.value.comp_start_date,
    comp_end_date: this.filterForm.value.comp_end_date
}
  this.dataService.post('comparative/callAttendedGraph', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.attendedCallPercentage(res['data']);
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}
public attendedCallPercentage(info) {
  Highcharts.chart('attendedCall', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y}%'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}%</b> of total<br/>'
    },
  
    series: [
      {
        name: "",
        colorByPoint: true,
        data: info
      }
    ]
  });
}

public leadTimeResponse(){

  this.dataService.startLoader();
  let finalData = {
    zone: this.apiReq.zone,
    region: this.apiReq.region,
    parent: this.apiReq.parent,
    outlet: this.apiReq.outlet,
    channel: this.channelName,
    start_date: this.filterForm.value.start_date,
    end_date: this.filterForm.value.end_date,
    comp_start_date: this.filterForm.value.comp_start_date,
    comp_end_date: this.filterForm.value.comp_end_date
}
  this.dataService.post('comparative/leadTimeResponseGraph', finalData).subscribe(res=>{
      this.dataService.stopLoader();
      if(res['code'] == 200){
          this.leadResponseChart(res['data']);
      }
      else{
          this.dataService.showError(res['message']);
          if(res['code'] == 401){
              this.dataService.logout();
          }
      }
  }, err=>{
      this.dataService.stopLoader();
      // this.dataService.showError(err['message']);
  })
}

public leadResponseChart(leadType) {
  Highcharts.chart('leadResponse_Time', {
    chart: {
      type: 'column'
    },
    exporting: { enabled: false },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    accessibility: {
      announceNewData: {
        enabled: true
      }
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: {
        text: ''
      }
  
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}%'
        }
      }
    },
  
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
    },
  
    series: [
      {
        name: "",
        colorByPoint: true,
        data: [
          {
            name: `< 30 mins (${this.filterForm.value.start_date} - ${this.filterForm.value.end_date})`,
            y: (leadType)? parseFloat(leadType.lt30per) : 0,
            drilldown: "< 30 mins"
          },{
            name: `< 30 mins (${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date})`,
            y: (leadType)? parseFloat(leadType.lt30perc) : 0,
            drilldown: "< 30 mins"
          },
          {
            name: `30 mins to 1 hr (${this.filterForm.value.start_date} - ${this.filterForm.value.end_date})`,
            y: (leadType) ? parseFloat(leadType.gt30lt1per): 0,
            drilldown: '30 mins to 1 hr'
          },
          {
            name: `30 mins to 1 hr (${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date})`,
            y: (leadType) ? parseFloat(leadType.gt30lt1perc): 0,
            drilldown: '30 mins to 1 hr'
          },
          {
            name: `1 hr to 2 hrs (${this.filterForm.value.start_date} - ${this.filterForm.value.end_date})`,
            y: (leadType) ? parseFloat(leadType.gt1lt2per) : 0,
            drilldown: "1 hr to 2 hrs"
          },
          {
            name: `1 hr to 2 hrs (${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date})`,
            y: (leadType) ? parseFloat(leadType.gt1lt2perc) : 0,
            drilldown: "1 hr to 2 hrs"
          },
          {
            name: `2 hrs to 4 hrs (${this.filterForm.value.start_date} - ${this.filterForm.value.end_date})`,
            y: (leadType)? parseFloat(leadType.gt2lt4per): 0,
            drilldown: "2 hrs to 4 hrs"
          },
          {
            name: `2 hrs to 4 hrs (${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date})`,
            y: (leadType)? parseFloat(leadType.gt2lt4perc): 0,
            drilldown: "2 hrs to 4 hrs"
          },
          {
            name: `4 hrs to 6 hrs (${this.filterForm.value.start_date} - ${this.filterForm.value.end_date})`,
            y: (leadType)? parseFloat(leadType.gt4lt6per): 0,
            drilldown: "4 hrs to 6 hrs"
          },
          {
            name: `4 hrs to 6 hrs (${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date})`,
            y: (leadType)? parseFloat(leadType.gt4lt6perc): 0,
            drilldown: "4 hrs to 6 hrs"
          },
          {
            name: `Post 6 hrs (${this.filterForm.value.start_date} - ${this.filterForm.value.end_date})`,
            y: (leadType)? parseFloat(leadType.gt6per): 0,
            drilldown: "Post 6 hrs"
          },
          {
            name: `Post 6 hrs (${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date})`,
            y: (leadType)? parseFloat(leadType.gt6perc): 0,
            drilldown: "Post 6 hrs"
          },
          {
            name: `Not attended (${this.filterForm.value.start_date} - ${this.filterForm.value.end_date})`,
            y: (leadType)? parseFloat(leadType.non_attendedper): 0,
            drilldown: "Not attended"
          },
          {
            name: `Not attended (${this.filterForm.value.comp_start_date} - ${this.filterForm.value.comp_end_date})`,
            y: (leadType)? parseFloat(leadType.non_attendedperc): 0,
            drilldown: "Not attended"
          }
        ]
      }
    ],
  });
}

}
